export default __webpack_public_path__ + "static/media/9.76fa64b8.png";